import APIrequest from '../../lib/axios';
import { PLAYERS_ENDPOINTS } from './endpoints';

export const playersService = {
  getAll: () => APIrequest({ method: 'GET', url: PLAYERS_ENDPOINTS.GET_ALL }),
  create: (data) => APIrequest({ method: 'POST', url: PLAYERS_ENDPOINTS.CREATE, bodyData: data }),
  update: (id, data) => APIrequest({ method: 'PUT', url: PLAYERS_ENDPOINTS.UPDATE(id), bodyData: data }),
  delete: (id) => APIrequest({ method: 'DELETE', url: PLAYERS_ENDPOINTS.DELETE(id) }),
  getById: (id) => APIrequest({ method: 'GET', url: PLAYERS_ENDPOINTS.GET_BY_ID(id) }),
};
